import { withPluginApi } from "discourse/lib/plugin-api";

// On the free tier, private (group-restricted) categories require a paid plan,
// so lock that visibility option on the General tab and show the upgrade modal
// instead of applying it.
export default {
  name: "register-category-visibility-callback",
  initialize(container) {
    withPluginApi((api) => {
      const siteSettings = container.lookup("service:site-settings");

      api.registerValueTransformer(
        "category-visibility-private-locked",
        ({ value }) => (siteSettings.discourse_tier === "free" ? true : value)
      );

      api.registerBehaviorTransformer(
        "category-visibility-change",
        ({ context, next }) => {
          if (
            siteSettings.discourse_tier === "free" &&
            context.nextVisibility === "group_restricted"
          ) {
            container
              .lookup("service:upgrade")
              .modalForPlan(
                "standard",
                "/edit-category/visibility private-category"
              );
            return;
          }

          return next();
        }
      );
    });
  },
};
